import React, {Fragment} from "react";
import {Button, Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {rankList, StateList, traversePropertiesString} from '../shared/shared';
import {getData} from "../../../api/doLogin";
import emailMask from '../shared/emailMask'

export function SpouseInfo(props) {
  const {values, handleCB, readonly, token, formFields} = props;

  function setFormFieldValue(field, value) {
    if (readonly) return;
    var objPost = {
      ...values,
      [field]: value,
    }
    handleCB(objPost);
  };

  function buildRank(branch) {
    let rankArray = rankList(branch) || [];
    return rankArray.map((value, index) => {
      return (
        <option key={index + 1} value={value}>{value}</option>
      );
    });
  }

  function getFormFieldValue(val) {
    if (val != null) {
      return val;
    } else {
      return "";
    }
  };

  function fetchZipDetails(zip, city, state) {
    if (readonly) return;
    if (zip.length === 0) {
      var objPost = {
        ...values,
        [city]: "",
        [state]: ""
      }
      handleCB(objPost);
      return;
    }
    getData("zip/get?zip=" + zip, {}, token)
      .then((data) => {
        if (data.status == "Success") {
          console.log(data.data);
          if (data.data.zipDetails.hasOwnProperty("city") && data.data.zipDetails.hasOwnProperty("state")) {
            var objPost = {
              ...values,
              [city]: data.data.zipDetails.city,
              [state]: data.data.zipDetails.state
            }
            handleCB(objPost);
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };
  return (
    <Fragment>
      <Row>
        <Col xs={"12"}>
          <h2>Spouse Information</h2>
        </Col>
      </Row>

      <Row>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="fname">First&nbsp;Name*</Label>
            <Input type="text" id="fname" placeholder=""
                   value={getFormFieldValue(values.fname)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
          </FormGroup>
        </Col>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor="middleInitial">Middle&nbsp;Initial</Label>
            <Input type="text" id="middleInitial" placeholder=""
                   value={getFormFieldValue(values.middleInitial)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
          </FormGroup>
        </Col>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="lname">Last&nbsp;Name*</Label>
            <Input type="text" id="lname" placeholder=""
                   value={getFormFieldValue(values.lname)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
          </FormGroup>
        </Col>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor="gender">Gender*</Label>
            <Input type="select" name="gender" id="gender"
                   value={getFormFieldValue(values.gender)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              <option key={1} value={"M"}>M</option>
              <option key={2} value={"F"}>F</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="bdate">Date of Birth*</Label>
            <TextMask
              mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id="bdate"
              value={getFormFieldValue(values.bdate)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
            />
            <FormText color="muted">
              MM/DD/YYYY (ex. 08/26/1984)
            </FormText>
          </FormGroup>
        </Col>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="ssn">SSN*</Label>
            <TextMask
              mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id={"ssn"}
              value={getFormFieldValue(values.ssn)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
            />
            <FormText color="muted">
              ex. 999-99-9999
            </FormText>
          </FormGroup>
        </Col>
        <Col xs={"6"}>
          <FormGroup>
            <Label htmlFor="tobacco">Used any form of Tobacco in the past 12 months?*</Label>
            <Input type="select" name="tobacco" id="tobacco"
                   value={getFormFieldValue(values.tobacco)}
                   onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              <option key={1} value={"Y"}>Yes</option>
              <option key={2} value={"N"}>No</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={"4"}>
          <h6>Current Mailing Address</h6>
        </Col>
        {getFormFieldValue(values.currentUseNew) !== "" ?
          <Button color="primary" onClick={(evt) => setFormFieldValue('currentUseNew', "")}>Use Primary
            Address</Button>
          :
          <Button color="primary" onClick={(evt) => setFormFieldValue('currentUseNew', "1")}>Enter New
            Address</Button>
        }
      </Row>
      {getFormFieldValue(values.currentUseNew) !== "" && (
      <Fragment>
        <Row>
          <Col xs={"7"}>
            <FormGroup>
              <Label htmlFor="currentAddress">Street&nbsp;Address*</Label>
              <Input type="text" id="currentAddress" placeholder=""
                     value={getFormFieldValue(values.currentAddress)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="currentZip">Zip*</Label>
              <Input type="text" id="currentZip" placeholder=""
                     value={getFormFieldValue(values.currentZip)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
                     onBlur={(evt) => fetchZipDetails(evt.target.value, "currentCity", "currentState")}/>
              <FormText color="muted">
                will autofill city/state
              </FormText>
            </FormGroup>
          </Col>
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="currentCity">City</Label>
              <Input type="text" id="currentCity" placeholder=""
                     value={getFormFieldValue(values.currentCity)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
            </FormGroup>
          </Col>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="currentState">State</Label>
              <Input type="select" name="currentState" id="currentState"
                     value={getFormFieldValue(values.currentState)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                <option key={0} value={""} disabled={true}>Choose</option>
                {StateList.map((value, index) => {
                  return (
                    <option key={index + 1} value={value.id}>{value.display}</option>
                  )
                })}
              </Input>
            </FormGroup>
          </Col>
        </Row>
      </Fragment>
      )}
      <br/>

      <Row>
        <Col xs={"4"}>
          <h6>Permanent Address</h6>
        </Col>
        <Col xs={"6"}>
          {getFormFieldValue(values.permanentUseNew) !== "" ?
            <Button color="primary" onClick={(evt) => setFormFieldValue('permanentUseNew', "")}>Use Current
              Address</Button>
            :
            <Button color="primary" onClick={(evt) => setFormFieldValue('permanentUseNew', "1")}>Enter New
              Address</Button>
          }
        </Col>
      </Row>
      {getFormFieldValue(values.permanentUseNew) !== "" && (
        <Fragment>
          <Row>
            <Col xs={"7"}>
              <FormGroup>
                <Label htmlFor="permanentAddress">Street&nbsp;Address*</Label>
                <Input type="text" id="permanentAddress" placeholder=""
                       value={getFormFieldValue(values.permanentAddress)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={"2"}>
              <FormGroup>
                <Label htmlFor="permanentZip">Zip*</Label>
                <Input type="text" id="permanentZip" placeholder=""
                       value={getFormFieldValue(values.permanentZip)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
                       onBlur={(evt) => fetchZipDetails(evt.target.value, "permanentCity", "permanentState")}/>
                <FormText color="muted">
                  will autofill city/state
                </FormText>
              </FormGroup>
            </Col>
            <Col xs={"3"}>
              <FormGroup>
                <Label htmlFor="permanentCity">City</Label>
                <Input type="text" id="permanentCity" placeholder=""
                       value={getFormFieldValue(values.permanentCity)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
              </FormGroup>
            </Col>
            <Col xs={"2"}>
              <FormGroup>
                <Label htmlFor="permanentState">State</Label>
                <Input type="select" name="permanentState" id="permanentState"
                       value={getFormFieldValue(values.permanentState)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                  <option key={0} value={""} disabled={true}>Choose</option>
                  {StateList.map((value, index) => {
                    return (
                      <option key={index + 1} value={value.id}>{value.display}</option>
                    )
                  })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </Fragment>
      )}

      <br/>

      <Row>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="phone">Home/Cell Phone*</Label>
            <TextMask
              mask={[/[2-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id="phone"
              value={getFormFieldValue(values.phone)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
            />
            <FormText color="muted">
              ###-###-####
            </FormText>
          </FormGroup>
        </Col>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor="workPhone">Work Phone</Label>
            <TextMask
              mask={[/[2-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              Component={InputAdapter}
              className="form-control"
              id="workPhone"
              value={getFormFieldValue(values.workPhone)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
            />
            <FormText color="muted">
              ###-###-####
            </FormText>
          </FormGroup>
        </Col>
        <Col xs={"6"}>
          <FormGroup>
            <Label htmlFor="email">Email*</Label>
            <TextMask
              mask={emailMask}
              Component={InputAdapter}
              className="form-control"
              id="email"
              value={getFormFieldValue(values.email)}
              onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
            />
            <FormText color="muted">
              valid email address, just type it
            </FormText>
          </FormGroup>
        </Col>
      </Row>

      {traversePropertiesString(formFields,['basic','milmembers'])==="2" && (
      <Fragment>
        <br/>

        <Row>
          <Col xs={"12"}>
            <h6>Service Information</h6>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3}>
            <FormGroup>
              <Label htmlFor="dutyStatus">Current&nbsp;Duty&nbsp;Status*</Label>
              <Input type="select" name="dutyStatus" id="dutyStatus"
                     value={getFormFieldValue(values.dutyStatus)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                <option key={0} value={""} disabled={true}>Choose</option>
                <option key={1} value={"2"}>Full-time AD</option>
                <option key={2} value={"1"}>Ready Reserve</option>
                <option key={3} value={"N"}>National Guard</option>
                <option key={4} value={"3"}>Retired</option>
                <option key={5} value={"7"}>Separated</option>
              </Input>
            </FormGroup>
          </Col>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="separationDate">Separation&nbsp;Date*</Label>
              <TextMask
                mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
                Component={InputAdapter}
                className="form-control"
                id="separationDate"
                value={getFormFieldValue(values.separationDate)}
                onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}
              />
              <FormText color="muted">
                MM/DD/YYYY (ex. 08/26/2024)
              </FormText>
            </FormGroup>
          </Col>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="branch">Branch*</Label>
              <Input type="select" name="branch" id="branch"
                     value={getFormFieldValue(values.branch)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                <option key={0} value={""} disabled={true}>Choose</option>
                <option key={1} value={"2"}>USA</option>
                <option key={2} value={"5"}>USN</option>
                <option key={3} value={"6"}>USAF</option>
                <option key={4} value={"4"}>USMC</option>
                <option key={5} value={"3"}>USCG</option>
              </Input>
            </FormGroup>
          </Col>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="rank">Rank*</Label>
              <Input type="select" name="rank" id="rank"
                     value={getFormFieldValue(values.rank)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}>
                <option key={0} value={""} disabled={true}>Choose</option>
                {buildRank(getFormFieldValue(values.branch))}
              </Input>
            </FormGroup>
          </Col>
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="serviceUnit">Assigned Unit</Label>
              <Input type="text" id="serviceUnit" placeholder=""
                     value={getFormFieldValue(values.serviceUnit)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value)}/>
            </FormGroup>
          </Col>
        </Row>
      </Fragment>
        )}
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/containers/Applications/sections/SpouseInfo.js